import React, { useMemo } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Box, Stack } from "@mui/material"

import { ACTIVE_KFC_BRANDS } from "../../utils"
import ProductHeaderActions from "./ProductHeaderActions"
import { getRecipeById } from "../../parseManager/recipe/parseRecipeManager"
import { deleteRecipe, duplicateRecipe } from "../../actions/Recipe/recipes"
import { getProductTypeLabelByProduct } from "../../utils/productTypesUtils"
import { getProductTypeOptionsSelector } from "../../reducers/ProductTypes/productTypes"

import CommentsIconBadge from "../Comments/CommentsIcon"
import PreviewHeader from "../PreviewHeader"
import CloudinaryImage from "../Image/CloudinaryImage"
import HeaderBrands from "./HeaderBrands"

export const Header = (props) => {
    const { image, jsonRecipe, enterprises = [], onToggleDrawer } = props

    const productTypeOptions = useSelector(getProductTypeOptionsSelector)

    const dispatch = useDispatch()

    const status = jsonRecipe && jsonRecipe.isActive
        ? "Actif"
        : "Inactif"

    const uniqueCode = jsonRecipe && jsonRecipe.uniqueCode
        ? jsonRecipe.uniqueCode
        : ""

    const brands = jsonRecipe && Array.isArray(jsonRecipe.brands) ? jsonRecipe.brands : []
    const recipeBrands = ACTIVE_KFC_BRANDS.filter(elem => brands.includes(elem.name))

    const recipeEnterpriseIds = jsonRecipe && Array.isArray(jsonRecipe.enterprises)
        ? jsonRecipe.enterprises.map((enterprise) => enterprise.objectId)
        : []
    const recipeEnterprises = enterprises.filter(enterprise => recipeEnterpriseIds.includes(enterprise.objectId))

    const onClickDelete = async () => {
        const recipe = await getRecipeById(jsonRecipe.objectId, [], false)
        dispatch(deleteRecipe(recipe, true))
    }

    const onClickDuplicate = (currentRecipeId, newRecipeName) => {
        dispatch(duplicateRecipe(currentRecipeId, newRecipeName, true))
    }

    const commentsCount = useMemo(() => {
        if (Array.isArray(jsonRecipe.comments)) {
            return jsonRecipe.comments.length
        }
        return 0
    }, [jsonRecipe])

    if (!jsonRecipe) {
        return null
    }

    const options = [
        { label: "Code", value: uniqueCode },
        { label: "Statut", value: status },
        { label: "Type", value: getProductTypeLabelByProduct(jsonRecipe, productTypeOptions) },
        {
            label: `Marque${recipeBrands.length > 1 ? "s" : ""}`,
            sx: { flex: 1, minWidth: 0 },
            value: <HeaderBrands jsonRecipe={jsonRecipe} brands={recipeBrands} />
        },
        ...(recipeEnterprises.length > 0 ? [{
            label: `Entreprise${recipeEnterprises.length > 1 ? "s" : ""}`,
            sx: { flex: 1 },
            value: (
                <Stack direction="row" gap={3}>
                    {recipeEnterprises.map((enterprise, index) => (
                        <Stack key={index} direction="row" alignItems="center">
                            {
                                enterprise.logo && enterprise.logo.publicId &&
                                <CloudinaryImage
                                    imageId={enterprise.logo.publicId}
                                    width={16}
                                    height={16}
                                    resize="fit"
                                />
                            }
                            <Box
                                component="span"
                                sx={sx.brandName}
                            >
                                {enterprise.name}
                            </Box>
                        </Stack>
                    ))}
                </Stack>
            )
        }] : [])
    ]

    return (
        <PreviewHeader
            image={image}
            title={jsonRecipe.commercialName}
            options={options}
            rightActions={
                <>
                    {onToggleDrawer && (
                        <CommentsIconBadge count={commentsCount} onToggle={onToggleDrawer} />
                    )}
                    <ProductHeaderActions
                        onClickDelete={onClickDelete}
                        onClickDuplicate={onClickDuplicate}
                        jsonData={jsonRecipe}
                        type={"RECIPE"}
                    />
                </>
            }
        />
    )
}

const sx = {
    brandsValueContainer: {
        display: "flex",
    },
    singleBrandContainer: {
        // alignItems: "center",
        // marginRight: "24px",
        marginTop: "8px",
    },
    brandName: {
        fontSize: "16px",
        marginLeft: "8px"
    }
}

export default Header
